import { render, staticRenderFns } from "./AddMilestone.vue?vue&type=template&id=47ef4b35&scoped=true&"
import script from "./AddMilestone.vue?vue&type=script&lang=js&"
export * from "./AddMilestone.vue?vue&type=script&lang=js&"
import style0 from "./AddMilestone.vue?vue&type=style&index=0&id=47ef4b35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ef4b35",
  null
  
)

export default component.exports